const type = 'SET_CARD_STATUSES';

const setCardStatuses = (data) => ({
  data,
  type,
});

export { type };
export default setCardStatuses;
